import * as React from 'react';

const SearchEmpty = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 450 450"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: 2 }}
        {...props}
    >
        <g transform="matrix(1,0,0,1,-6086.32,-2519.69)">
            <g id="SearchEmpty" transform="matrix(1,0,0,1,2586.32,2519.69)">
                <g transform="matrix(1.36943,0,0,1.38264,3471.66,-437.974)">
                    <ellipse cx="185" cy="479.5" rx="157" ry="155.5" fill="#FAFAFA" />
                </g>
                <g transform="matrix(1,0,0,1,-2609.39,-2539.25)">
                    <text x="6286.53px" y="2840.17px" fill="#B8B9C5" fontFamily="Georgia, serif" fontSize="200px">
                        ?
                    </text>
                </g>
                <g id="Search" transform="matrix(8.47539,5.22336e-31,-1.04467e-31,8.47539,-41782.6,-2352.58)">
                    <path
                        d="M5378.55,318.058C5375.82,320.091 5372.43,321.294 5368.76,321.294C5359.7,321.294 5352.35,313.952 5352.35,304.895C5352.35,295.838 5359.7,288.495 5368.76,288.495C5377.82,288.495 5385.17,295.838 5385.17,304.895C5385.17,308.808 5383.8,312.401 5381.51,315.221L5391.79,326.032C5392.57,326.853 5392.53,328.15 5391.71,328.93C5390.89,329.71 5389.59,329.676 5388.81,328.855L5378.55,318.058ZM5368.76,317.194C5361.97,317.194 5356.46,311.687 5356.46,304.895C5356.46,298.102 5361.97,292.595 5368.76,292.595C5375.56,292.595 5381.07,298.102 5381.07,304.895C5381.07,311.687 5375.56,317.194 5368.76,317.194Z"
                        fill="#00022D"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default SearchEmpty;
